const now = parseInt(new Date().getTime() / 1000);
const dataToImport = {
  database: "ariposappdb",
  version: 1,
  encrypted: false,
  mode: "full",
  tables: [
    {
      name: "locations",
      schema: [
        { column: "id", value: "INTEGER PRIMARY KEY" },
        { column: "lat", value: "TEXT" },
        { column: "lng", value: "TEXT" },
        { column: "datetime", value: "TEXT" },
      ],
      values: [],
    },
    {
      name: "configurations",
      schema: [
        { column: "id", value: "INTEGER PRIMARY KEY" },
        { column: "token", value: "TEXT" },
        { column: "data_login", value: "TEXT" },
      ],
      values: [],
    },
    {
      name: "permissions",
      schema: [
        { column: "id", value: "INTEGER PRIMARY KEY" },
        { column: "name", value: "TEXT" },
        { column: "status", value: "TEXT" },
      ],
      values: [],
    },
    {
      name: "activities",
      schema: [
        { column: "id", value: "INTEGER PRIMARY KEY" },
        { column: "log_name", value: "TEXT" },
        { column: "description", value: "TEXT" },
        { column: "date", value: "TEXT" },
        { column: "user_id", value: "TEXT" },
        { column: "other", value: "TEXT" }
      ],
      values: [],
    }
  ],
};
export default dataToImport;
